import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    class: { type: String, default: "select_field" }
  };

  get fieldSelector() {
    return 'input, select, textarea';
  }

  connect() {
    this.show();
  }

  get currentTargetValue() {
    const checkedRadio = this.element.querySelector('input[type="radio"]:checked');
    if (checkedRadio) return checkedRadio.value;

    return this.element.value || "";
  }

  show() {
    const targetValue = this.currentTargetValue;
    const targetClass = `${targetValue}_field`;
    const wrappers = document.getElementsByClassName(this.classValue);

    Array.from(wrappers).forEach((element) => {
      const isTarget = element.classList.contains(targetClass);
      const isRequired = element.classList.contains("required_field");
      const fields = element.querySelectorAll(this.fieldSelector);

      if (isTarget) {
        element.classList.remove("hidden");
        element.disabled = false;

        fields.forEach((field) => {
          field.disabled = false;

          const isFieldRequired = isRequired && !field.classList.contains("not-required");

          const isTomInput = field.getAttribute('role') === 'combobox' || field.id.includes('-ts-control');

          if (isFieldRequired && !isTomInput) {
            field.required = true;
          }

          if (field.tomselect) {
            field.tomselect.enable();
            if (field.tomselect.controlInput) {
              field.tomselect.controlInput.removeAttribute('required');
            }
          }
        });

      } else {
        element.classList.add("hidden");
        element.disabled = true;

        fields.forEach((field) => {
          field.required = false;
          field.disabled = true;

          if (field.tomselect) {
            field.tomselect.disable();
            if (field.tomselect.controlInput) {
              field.tomselect.controlInput.removeAttribute('required');
            }
          }

          if (field.getAttribute('role') === 'combobox') {
            field.removeAttribute('required');
          }
        });
      }
    });
  }
}
